// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_background__nUocA {
  background-color: #0f2047;
}

.styles_logoMenu__R\\+cK\\+ {
  width: 180px !important;
  height: auto !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/PageNotFound/styles.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB","sourcesContent":[".background {\n  background-color: #0f2047;\n}\n\n.logoMenu {\n  width: 180px !important;\n  height: auto !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `styles_background__nUocA`,
	"logoMenu": `styles_logoMenu__R+cK+`
};
export default ___CSS_LOADER_EXPORT___;
